import { Component } from "@angular/core";

@Component({
  selector: 'app-tabs-filter',
  standalone: true,
  imports: [],
  templateUrl: './tabs-filter.component.html',
  styleUrl: './tabs-filter.component.scss',
  host: {
    class: 'inline-flex space-x-2',
  },
})
export class TabsFilterComponent {
}
